// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"29ad1b4c","453":"b5730b63","644":"0998a1eb","832":"9bb154a5","919":"51cbcbe0"}[chunkId] + ".chunk.js";
};